export default {
  //#region 登录
  login: {
    username: "Please enter your account",
    password: "Please enter your password",
    login: "Log in now",
    Switch_to_Chinese: "Switch to Chinese",
    Switch_to_English: "Switch to English",
  },

  //#endregion

  //#region 顶部状态栏
  topbar: {
    我的主页: "My Home",
    控制台: "Console",
    项目主页: "Project Home",
    项目设置: "Project Setting",
    项目: "Project",
    公司: "Company",
  },
  //#endregion

  //#region 我的主页
  我的主页: {
    全部: "All",
    我加入的: "Projects I Joined",
    我管理的: "Projects I Manage",
    请输入项目名称: "Please enter project name",
    按时间排序: "Sort by Time",
    按合同排序: "Sort by Contract",
    按规模排序: "Sort by Scale",
    按人力排序: "Sort by Manpower",
    管理: "Manage",
    协作: "Collaborate",
    最近打开的文件: "Recently Opened Files",
  },
  //#endregion

  //#region  项目设置控制台
  项目设置侧边栏: {
    项目信息: "Project Information",
    通知管理: "Notification Management",
    应用导航: "Application Navigation",
    成员管理: "Member Management",
    岗位权限: "Position Permissions",
    资料管理: "Document Management",
    进度状态设置: "Progress Status Settings",
    工程动态设置: "Project Dynamics Settings",
    话题讨论标签: "Discussion Topic Tags",
    工单标签设置: "Work Order Tag Settings",
    实景标签设置: "Real Scene Tag Settings",
  },
  通知管理: {
    通知管理: "Notification Management",
    序号: "No.",
    名称: "Name",
    发布者: "Publisher",
    更新时间: "Update Time",
    操作: "Operation",
    新建通知: "Create Notification",
    时间: "Time",
    标题颜色: "Title Color",
    内容: "Content",
    编辑公告信息: "Edit Announcement Information",
    排序: "Sort",
  },
  作业面: {
    作业面维护: "Work Area Maintenance",
    关联: "Associate",
    序号: "No.",
    模型名称: "Model Name",
    选择集名称: "Selection Set Name",
    版本备注: "Version Notes",
    更新时间: "Update Time",
    模型选择集: "Model Selection Set",
    注意:
      "Note: When the type is single model or selection set, only one model can be selected; when merging models, multiple models can be loaded together. Save viewpoint and selection set operations are only available for single model types.",
    单模: "Single Model",
    选择集: "Selection Set",
    合模: "Merge Models",
  },
  成员管理: {
    成员管理: "Member Management",
    显示全部成员: "Show All Members",
    请输入用户姓名: "Please enter user name",
    邀请: "Invite",
    导出: "Export",
    移除: "Remove",
    账号: "Account",
    姓名: "Name",
    性别: "Gender",
    组织机构: "Organization",
    岗位: "Position",
    邮箱: "Email",
    手机号: "Phone Number",
    状态: "Status",
    操作: "Operation",
    查看: "View",
    查看成员: "View Member",
    编辑成员: "Edit Member",
    请选择组织: "Please select organization",
    请选择岗位: "Please select position",
    选择邀请账号信息: "Please select invitation account information",
    地址: "Address",
  },
  岗位权限: {
    岗位权限: "Position Permissions",
    重命名: "Rename",
    复制: "Copy",
    权限: "Permission",
    移除岗位: "Remove Position",
    添加岗位: "Add Position",
    岗位名称: "Position Name",
    权限管理: "Permission Management",
    项目管理: "Project Management",
    团队成员: "Team Members",
    电话加密: "Phone Encryption",
    邮箱加密: "Email Encryption",
    使用话题讨论: "Use Topic Discussion",
    协作沟通: "Collaborative Communication",
    使用工单任务: "Use Work Order Tasks",
    发起任务: "Initiate Task",
    进度管理: "Progress Management",
    三维模拟: "3D Simulation",
    进度计划: "Progress Planning",
    新建: "Create",
    删除: "Delete",
    进度展示: "Progress Display",
    查看: "View",
    编辑: "Edit",
    资料管理: "Document Management",
    分享: "Share",
    查看关联: "View Association",
    下载: "Download",
    图纸管理: "Drawing Management",
    条码管理: "Barcode Management",
    生成: "Generate",
    打印: "Print",
    实景管理: "Reality Capture Management",
    上传: "Upload",
    请输入岗位名称: "Please enter position name",
    账号: "Account",
    姓名: "Name",
    组织机构: "Organization",
    岗位: "Position",
    邮箱: "Email",
    手机号: "Phone Number",
    操作: "Operation",
  },
  资料管理: {
    资料管理: "Document Management",
    资料目录树: "Document Directory Tree",
    资料目录导入: "Import Excel",
    资料目录导出: "Export Excel",
    设置: "Settings",
    资料标签: "Document Tags",
    显示全部人员: "Show All Personnel",
    当前节点是否需要审核: "Does current node require approval",
    是: "Yes",
    否: "No",
    已选择人员: "Selected Personnel",
    提交: "Submit",
    序号: "Serial Number",
    账号: "Account",
    姓名: "Name",
    所属组织: "Affiliated Organization",
    岗位: "Position",
    邮箱: "Email",
    手机号: "Phone Number",
    名称: "Name",
    文件数量: "File Count",
    维护人员: "Maintainer",
    更新时间: "Update Time",
    设置可见人员审核: " Set Visible Personnel/Audit",
    不选择为全部可见: "Not Selecting All Visible",
  },
  进度状态设置: {
    进度状态设置: "Progress Status Settings",
    排序: "Sort",
    状态名称: "Status Name",
    颜色: "Color",
    更新时间: "Update Time",
    操作: "Operation",
    设置进度状态: "Set Progress Status",
  },
  工程动态标签: {
    工程动态标签: "Project Dynamics Tags",
    序号: "No.",
    名称: "Name",
    更新时间: "Update Time",
    操作: "Operation",
    重命名: "Rename",
  },
  话题讨论标签: {
    话题讨论标签: "Topic Discussion Tags",
    类型: "Type",
    图片: "Image",
    操作: "Operation",
    添加标签: "Add Tag",
    修改标签: "Modify Tag",
    选取文件: "Select File",
  },
  工单标签设置: {
    工单标签设置: "Work Order Label Settings",
    编辑工单标签: "Edit Work Order Label",
    排序: "Sort",
    名称: "Name",
    底纹颜色: "Background Color",
    文字颜色: "Text Color",
    维护人员: "Maintainer",
    更新时间: "Update Time",
    操作: "Operation",
    新增工单标签: "Add Work Order Label",
    修改工单标签: "Modify Work Order Label",
  },
  实景标签配置: {
    实景标签配置: "Reality Capture Label Configuration",
    类型: "Type",
    图片: "Image",
    操作: "Operation",
    全景: "Panorama",
    全景链接: "Panorama",
    视频: "Video",
    选取文件: "Select File",
    全部: "All",
  },
  //#endregion

  //#region 企业管理
  控制台侧边栏: {
    企业管理: "Enterprise Management",
    项目管理: "Project Management",
    模型管理: "Model Management",
    人员管理: "Personnel Management",
    操作管理: "Operation Management",
  },
  企业管理: {
    企业管理: "Enterprise Management",
    单位简称: "Unit Abbreviation",
    单位名称: "Unit Name",
    企业编码: "Enterprise Code",
    单位类别: "Unit Category",
    地址: "Address",
    邮箱: "Email",
    电话: "Phone",
    网址: "Website",
    项目容量: "Project Capacity",
    空间容量: "Space Capacity",
    成员容量: "Member Capacity",
    授权期限: "Authorization Period",
    高级授权: "Advanced Authorization",
  },
  //#endregion

  //#region 项目管理
  项目管理: {
    项目管理: "Project Management",
    显示全部项目: "Show All Projects",
    序号: "No.",
    项目名称: "Project Name",
    项目简称: "Project Abbreviation",
    项目编号: "Project Number",
    BIM负责人: "BIM Manager",
    所属分组: "Group",
    项目类型: "Project Type",
    建设单位: "Construction Unit",
    项目地点: "Project Location",
    创建时间: "Creation Time",
    模型: "Model",
    新建项目: "Create Project",
    请输入项目名称: "Please enter project name",
  },
  新建项目: {
    项目详情: "Project Details",
    新建项目: "Create Project",
    项目编号: "Project Number",
    项目名称: "Project Name",
    BIM负责人: "BIM Manager",
    所属分组: "Group",
    项目类型: "Project Type",
    项目简称: "Project Abbreviation",
    合同金额: "Contract Amount",
    BIM耗时: "BIM Time Consumption",
    服务阶段: "Service Stage",
    总体投资: "Total Investment",
    项目规模: "Project Scale",
    项目地点: "Project Location",
    总体工期: "Total Construction Period",
    建设单位: "Construction Unit",
    设计单位: "Design Unit",
    施工单位: "Construction Unit",
    监理单位: "Supervision Unit",
    开工竣工: "Start and Completion",
    开工日期: "Start Date",
    竣工日期: "Completion Date",
    一次设计: "Primary Design",
    深化设计: "Detailed Design",
    外包设计: "Outsourced Design",
    计划竣工: "Planned Completion",
    创建日期: "Creation Date",
    项目概况: "Project Overview",
    保存: "Save",
    还原: "Restore",
    项目照片: "Project Photos",
  },
  模型列表: {
    模型列表: "Model List",
    序号: "No.",
    文件名称: "File Name",
    专业备注: "Professional Remarks",
    文件大小: "File Size",
    上传文件大小: "Upload File Size",
    版本备注: "Version Remarks",
    联系人: "Contact Person",
    邮箱: "Email",
    电话: "Phone",
    备注: "Remarks",
    更新时间: "Update Time",
    操作: "Operation",
    请输入模型名称: "Please enter model name",
    浏览: "Browse",
    卸载: "Unload",
    加载模型: "Load Model",
    确定加载: "Confirm Load",
    上传模型: "Upload Model",
    更新模型: "Update Model",
    转换记录: "Conversion Records",
    转换类型: "Conversion Type",
    用时: "Time Taken",
    创建时间: "Creation Time",
    所属项目: "Belonging Project",
    转换状态: "Conversion Status",
    转换中: "Converting",
    转换成功: "Conversion Successful",
    转换失败: "Conversion Failed",
    选择上传模型的类型: "Select Model Upload Type",
    上传SVFZIP文件: "Upload SVF/ZIP File",
    上传RVTNWD文件: "Upload RVT/NWD File",
    通过AUTODESK云端进行轻量化转后的文件:
      "Files converted through AUTODESK cloud lightweight conversion",
    上传REVITNAVISWORKS文件并转化: "Upload REVIT/NAVISWORKS file and convert",
    上传到服务器并进行模型转换时间较长请耐心等待:
      "Uploading to server and converting model, this may take some time, please be patient...",
    模型文件: "Model File",
    点击上传: "Click to upload",
    请选择文件后上传: "Please select the file to upload",
  },
  //#endregion

  //#region 人员管理
  人员管理: {
    人员管理: "Personnel Management",
    显示全部人员: "Show All Personnel",
    请输入用户姓名: "Please enter user name",
    导入Excel: "Import Excel",
    职位管理: "Position Management",
    新建: "Create",
    邀请: "Invite",
    导出: "Export",
    点击下载模板文件: "Click to download template file",
    并按要求填好后上传: "Fill in as required and upload",
    选择文件: "Select File",
    上传到服务器: "Upload to Server",
    只能上传xlsx文件: "Only xlsx files can be uploaded",
    新增职位: "Add Position",
    职位名称: "Position Name",
    操作: "Operation",
    重命名: "Rename",
    移除: "Remove",
    提示: "Tips",
    请输入职位名称: "Please enter position name",
    新建账户信息: "Create Account Information",
    姓名: "Name",
    账号: "Account",
    手机号: "Mobile Phone",
    邮箱: "Email",
    登录密码: "Login Password",
    重复密码: "Repeat Password",
    所属组织: "Organization",
    职位: "Position",
    性别: "Gender",
    项目经理: "Project Manager",
    项目总工: "Chief Engineer",
    BIM经理: "BIM Manager",
    BIM工程师: "BIM Engineer",
    BIM负责人: "BIM Director",
    性别: "Gender",
    男: "Male",
    女: "Female",
    出生年月: "Date of Birth",
    职称: "Professional Title",
    初级: "Junior",
    中级: "Intermediate",
    副高级: "Associate Senior",
    高级: "Senior",
    学历: "Education",
    毕业院校: "Graduated School",
    联系地址: "Contact Address",
    输入邀请账户信息: "Enter invitation account information",
    账号手机号邮箱: "Account",
    部门: "Department",
    职位: "Position",
    邀请: "Invite",
    启用禁用: "Enable/Disable",
    到期时间: "Expiration Time",
    查看: "View",
    机构组织: "Organization",
    担任职位: "Position Held",
    管理的项目: "Managed Projects",
    参与的项目: "Participating Projects",
    项目编号: "Project Number",
    项目简称: "Project Abbreviation",
    岗位: "Post",
    序号: "No.",
    创建日期: "Create Date",
    查看用户详情: "View User Details",
    选择到期时间: "Select Expiration Date",
    不选则为永久有效: "Not Selected for Permanent Efficacy",
    此操作会将此人移除该公司是否继续:
      " This operation will remove this person from the company. Do you want to continue?",
  },
  //#endregion

  //#region 操作列表
  操作列表: {
    操作列表: "Operation List",
    用户姓名: "User Name",
    开始日期: "Start Date",
    结束日期: "End Date",
    操作内容: "Operation Content",
    查询: "Query",
    删除记录: "Delete Record",
    用户姓名: "User Name",
    账户: "Account",
    操作模块: "Operation Module",
    操作时间: "Operation Time",
  },
  //#endregion

  //#region 个人中心
  personcenter: {
    个人中心: "Personal center",
    修改密码: "Change your password",
    加入企业: "Join the enterprise",
    退出登录: "Log out",
    消息通知: "Message notifications",
    单位名称: "Unit name",
    单位类别: "Unit Category",
    邮箱: "mailbox",
    联系地址: "Contact address",
    电话: "Phone",
    网址: "URL",
    姓名: "name",
    性别: "gender",
    男: "man",
    女: "woman",
    账户: "ccount",
    出生年月: "Date of birth",
    地址: "Address",
    职称: "job title",
    学历: "Degree",
    手机号: "Mobile phone number",
    更换手机号: "Change your phone number",
    修改密码: "change password",
    旧密码: "old password",
    新密码: "new password",
    确认密码: "confirm password",
  },
  //#endregion

  //#region 通用
  common: {
    同意询问: "Are you sure to agree?",
    删除询问: "Are you sure to delete?",
    拒绝询问: "Are you sure to reject?",
    同意: "Yes",
    拒绝: "No",
    删除: "Delete",
    确定: "Yes",
    取消: "Cancel",
    添加: "Add",
    请填写必填项: "Please fill in the required items",
    处理成功: "handled successfully",
    处理失败: "handled failed",
    账户已存在: "Account already exists",
    修改: "Modify",
    删除: "Delete",
    操作: "Operation",
    提示: "Tips",
    新建节点: "New Node",
    请选择文件后上传: "Please select a file to upload",
    请先选择: "Please select first",
    请输入内容: "Please enter content",
    只能选择一个: "Only one can be selected",
    至少保留一个: "At least one node must be retained",
    上传类型错误: "Upload type error",
    当前用户在此项目中未设置角色请联系管理员:
      "The current user has not been set a role in this project, please contact the administrator",
    创建批注: "Create Annotation",
    批注列表: "Annotation List",
    添加批注: "Add Annotation",
    问题描述: "Problem Description",
    问题截图: "Problem Screenshot",
    审图要点: "Audit Points",
    文件关联: "File Association",
    本地上传: "Local Upload",
    问题类型: "Problem Type",
    专业: "Professional",
    修改方: "Modification Party",
    位置: "Location",
    清空: "Clear",
    创建: "Create",
    创建时间: "Creation Time",
    请输入搜索内容: "Please enter the search content",
    发表回复: "Post Reply",
    所属文件: "Belonging File",
    问题状态: "Problem Status",
    创建人: "Creator",
    状态: "Status",
    内容: "Content",
    图片预览: "Image Preview",
    请先进行模型转换: "Please perform model conversion first",
    转换中: "Converting",
    转换失败: "Conversion failed",
    转换成功: "Conversion succeeded",
    关闭: "Close",
    最大化: "Maximize",
    最小化: "Minimize",
    批注详情: "Annotation Details",
    活动: "Activity",
    涂鸦: "Annotation",
  },
  //#endregion

  //#region 超级管理员
  superAdmin: {},
  //#endregion

  //#region 侧边菜单栏
  xmzycbl: {
    projectHome: "Project Home",
    ApplicationNavigation: "Application Navigation",
    DirectoryOfCommunications: "Directory Of Communications",
    ListOfannotations: "List Of Annotations",
    ProjectData: "Project Data",
    PersonalData: "Personal Data",
    ProgressDisplay: "Progress Display",
    ProjectUpdates: "Project Updates",
    EngineeringDynamic: "Engineering Dynamic",
    DiscussTheTopic: "Discuss The Topic",
    WorkOrderTask: "Work Order Task",
    RealScenicSpot: "Real Scenic Spot",
  },
  //#endregion

  //#region 项目主页
  xmzy: {
    ProjectDetails: "Project Details",
    ProjectName: "Project Name",
    ProjectNumber: "Project Number",
    StartDate: "Start Date",
    ScheduledToBeCompleted: "Scheduled to be completed",
    ProjectManager: "Project Manager",
    Overallconstructionperiod: "Overall construction period",
    ConsultingContracts: "Consulting contracts",
    OverallInvestment: "Overall Investment",
    Projectaddress: "Project address",
    ProjectNotice: "Project Notice",
    Todotasks: "To do Tasks",
    DataDynamics: "Data dynamics",
    Formtodo: "Form to do",
    Progresstobedone: "Progress to be done",
    Workorderpending: "Work order pending",
    Workdynamics: "Work dynamics",
    无标题: "No Title",
    项目通知: "Project Notice",
    内容: "Content",
  },
  //#endregion

  //#region 通讯目录
  txml: {
    NewsletterDirectory: "Newsletter Directory",
    显示全部成员: "Show All Members",
    序号: "No.",
    账号: "Account",
    姓名: "Name",
    所属组织: "Organization",
    岗位: "Position",
    邮箱: "Email",
    手机号: "Mobile Number",
  },
  //#endregion

  //#region 批注列表
  pzlb: {
    批注列表: "Annotation List",
    专业: "Professional",
    问题分类: "Problem Classification",
    状态: "Status",
    描述: "Description",
    修改方: "Modifier",
    创建人: "Creator",
    创建时间: "Creation Time",
    操作: "Operation",
    请输入关键字进行搜索: "Please enter the keyword to search:",
    详情: "Details",
    删除: "Delete",
    打开: "Open",
    问题回复: "Problem Reply",
    发表回复: "Post Reply",
    待修改: "To be modified",
    已修改: "Modified",
    不修改: "Not Modified",
    已销项: "Closed",
    内容: "Content",
    所属文件: "Associated File",
    问题状态: "Problem Status",
    问题描述: "Problem Description",
    审图要点: "Review Points",
    关联文件: "Associated File",
    问题类型: "Problem Type",
    位置: "Location",
    活动: "Activity",
    请输入回复内容最多可输入200字:
      "Please enter the reply content, up to 200 characters",

    其他: "Other",
    图面问题: "Drawing Issues",
    图纸缺失: "Missing Drawings",
    图纸不一致: "Inconsistent Drawings",
    净高问题: "Clear Height Issues",
    碰撞问题: "Collision Issues",
    预留洞口: "Reserved Openings",
    设计优化: "Design Optimization",
    项目管理: "Project Management",
    总图: "Master Plan",
    建筑: "Architecture",
    结构: "Structure",
    给排水: "Plumbing",
    暖通: "HVAC",
    电气: "Electrical",
    人防: "Civil Defense",
    智能化: "Intelligentization",
    BIM: "BIM",
    装配式: "Prefabricated",
    景观: "Landscape",
    精装: "Finishing",
    规划: "Planning",
    经济: "Economy",
    钢结构: "Steel Structure",
    综合机电: "Integrated MEP",
    幕墙: "Curtain Wall",
    打开当前浏览器在地址栏输入: "Open the current browser and enter the address bar:",
    复制地址: "Copy Address",
    在打开的界面中下拉框选择enabled地址填写你的项目访问路径: 'In the opened interface, select the enabled address and fill in your project access path:',
    复制访问路径: "Copy Access Path",
    点击截图自动上传: "Click to automatically upload the screenshot",
  },
  //#endregion

  //#region 项目资料
  xmzl: {
    项目资料: "Project Data",
    请选择文件类型: "Please select the file type",
    请选择标签: "Please select a label",
    请输入文件名称关键词: "Please enter the file name keyword",
    全部: "All",
    我上传的: "Uploaded by me",
    我收藏的: "Collected by me",
    分享: "Share",
    分享管理: "Share Management",
    删除: "Delete",
    序号: "No.",
    文件名称: "File Name",
    剩余天数: "Remaining Days",
    操作: "Operation",
    复制链接: "Copy Link",
    取消分享: "Cancel Share",
    大小mb: "Size (MB)",
    文件类型: "File Type",
    标签: "Label",
    上传时间: "Upload Time",
    上传用户: "Uploaded By",
    可见范围: "Visible Range",
    收藏: "Collect",
    取消收藏: "Cancel Collect",
    修改: "Modify",
    下载: "Download",
    公开: "Public",
    半公开: "Semi-public",
    标签设置: "Label Settings",
    可见设置: "Visible Settings",
    添加可见人员: "Add Visible People",
    根目录: "Root Directory",
    请选择: "Please Select",
    新增资料: "Add Data",
    点击转换: "Click to Convert",
    转换中请稍等: "Converting, please wait",
    未转换: "Not Converted",
    转换中: "Converting",
    转换失败: "Conversion Failed",
    转换成功: "Conversion Successful",
    选取文件: "Select File",
    上传: "Upload",
    取消: "Cancel",
    请选择人员: "Please Select People",
    请输入名称: "Please Enter Name",
    确定: "Confirm",
    账号: "Account",
    姓名: "Name",
    分享资料: "Share Data",
    "1": "one days",
    "7": "seven days",
    "30": "thirty days",
    永久有限: "Permanent & Limited",
    移动分组: "Move Group",
    名称: "Name",
    部分可见: "Partially Visible",
    请先做选择: "Please make a selection first",
    修改可见: "Modify Visibility",
    选择标签: "Select Label",
    上传文件: "Upload File",
    选择文件夹: "Select Folder",
  },
  //#endregion

  //#region 我的资料
  我的资料: {
    我的资料: "My Data",
    请选择文件类型: "Please select the file type",
    请选择标签: "Please select a label",
    请输入文件名称关键词: "Please enter the file name keyword",
    全部: "All",
    我上传的: "Uploaded by me",
    我收藏的: "Collected by me",
    分享: "Share",
    分享管理: "Share Management",
    删除: "Delete",
    序号: "No.",
    文件名称: "File Name",
    剩余天数: "Remaining Days",
    操作: "Operation",
    复制链接: "Copy Link",
    取消分享: "Cancel Share",
    大小mb: "Size (MB)",
    文件类型: "File Type",
    标签: "Label",
    上传时间: "Upload Time",
    上传用户: "Uploaded By",
    可见范围: "Visible Range",
    收藏: "Collect",
    取消收藏: "Cancel Collect",
    修改: "Modify",
    下载: "Download",
    公开: "Public",
    半公开: "Semi-public",
    标签设置: "Label Settings",
    可见设置: "Visible Settings",
    添加可见人员: "Add Visible People",
    根目录: "Root Directory",
    请选择: "Please Select",
    新增资料: "Add Data",
    点击转换: "Click to Convert",
    转换中请稍等: "Converting, please wait",
    未转换: "Not Converted",
    转换中: "Converting",
    转换失败: "Conversion Failed",
    转换成功: "Conversion Successful",
    选取文件: "Select File",
    上传: "Upload",
    取消: "Cancel",
    请选择人员: "Please Select People",
    请输入名称: "Please Enter Name",
    确定: "Confirm",
    账号: "Account",
    姓名: "Name",
    分享资料: "Share Data",
    永久有限: "Permanent & Limited",
    移动分组: "Move Group",
    名称: "Name",
    部分可见: "Partially Visible",
    请先做选择: "Please make a selection first",
    批量下载: "Batch Download",
    批量删除: "Batch Delete",
    批量移动: "Batch Move",
    新增资料: "Add Data",
    移动: "Move",
    资料预览: "Data Preview",
    管理个人审核模块: "Manage Personal Audit Module",
    确认并提交审核: "Confirm and Submit for Review",
    选择审批模块: "Select Approval Module",
    试试搜索: "Try Searching",
    流程节点: "Process Node",
    审批人: "Approver",
    审批性质: "Approval Nature",
    个人预定义审核流程模板管理:
      "Personal Predefined Audit Process Template Management",
    新建: "New",
    流程环节详情: "Process Link Details",
    审核名称: "Audit Name",
    立即创建: "Create Now",
    驳回信息: "Rejection Information",
    时间: "Time",
    内容: "Content",
    成功: "Success",
    失败: "Failed",
    请勾选报审资料: "Please check the data to be reviewed",
    请先选择: "Please select first",
    是否移动该资料: "Whether to move this data?",
    提示: "Prompt",
    新建文件夹: "New Folder",
    上传: "Upload",
    文件: "File",
    文件夹: "Folder",
    移动到: "Move to",
    文件大小: "File Size",
    更新时间: "Update Time",
    状态: "state",
    请输入文件夹名称: "Please enter folder name",
    文件夹名称不符合规范: "Name does not comply with specifications! Allowed: Chinese, English, numbers, underscores (_), hyphens (-), spaces, dots (.)",
    文件夹重复: "Folder already exists",
    上传中: "Uploading",
    上传成功: "Upload Successful",
    上传失败: "Upload Failed",
    不能移动到当前目录下: "Cannot move to the current directory",
    选择文件移动时必须选择目标文件夹: "When moving files, a target folder must be selected",
    移动失败当前目录下已有此名称: "Move failed, a file with this name already exists in the current directory",
    回收站: "Recycle Bin",
    高级查询: "Advanced Search",
    修改人: "Modifier",
    还原: "Restore",
    上传列表: "Upload List",
    列表: "List",
    宫格: "Grid",
    请选择文件夹: "Please select a folder",
    根目录只能上传文件夹: "Root directory can only upload folders",
  },
  //#endregion

  //#region 进度展示
  进度展示: {
    高级筛选: "Advanced filtering",
    模型选择: "Model Selection",
    全选: "Select All",
    取消全选: "Deselect All",
    添加: "Add",
    修改: "Modify",
    删除: "Delete",
    名称: "Name",
    请输入名称: "Please enter a name",
    状态: "Status",
    请选择状态: "Please select status",
    提交: "Submit",
    初始化模型数据中: "Initializing model data...",
    筛选条件: "Filter Condition",
    并且: "And",
    或者: "Or",
    大于: "Greater Than",
    小于: "Less Than",
    等于: "Equal To",
    包含: "Contains",
    立即查询: "Immediate Query",
    筛选范围: "Filter Range",
    当前选择构件: "Current Selection",
    无选择则以全模型: "No selection means the entire model",
    刷新数据: "Refresh Data",
    请填写完整筛选条件: "Please fill in the complete filter conditions",
    一共查找出: "A total of",
    暂无符合条件的构件: "No components meet the conditions",
    请填写节点名称: "Please fill in the node name!",
    成功: "Success",
    失败: "Failed",
    当前项目未设置进度状态:
      "The current project has not set the progress status",
  },
  //#endregion

  //#region 工程动态
  工程动态: {
    工程动态: "Project News",
    至: "To",
    开始日期: "Start Date",
    结束日期: "End Date",
    请选择动态标签: "Please select a dynamic label",
    请选择分类: "Please select a category",
    发布动态: "Publish News",
    动态: "News",
    请输入标题: "Please enter a title",
    请选择分类: "Please select a category",
    选择日期时间: "Select Date & Time",
    确定: "Confirm",
    取消: "Cancel",
    最近一周: "Last Week",
    最近一月: "Last Month",
    最近三个月: "Last Three Months",
    公开: "Public",
    私人: "Private",
    成功: "Success",
    失败: "Failed",
    请选择时间: "Please select a time",
    请输入标题: "Please enter a title",
    请输入内容: "Please enter content",
  },
  //#endregion

  //#region 话题讨论
  话题讨论: {},
  //#endregion

  //#region 工单任务
  工单任务: {
    工单任务: "Work Order",
    序号: "No.",
    任务名称: "Task Name",
    发起人: "Initiator",
    计划完成时间: "Planned Completion Time",
    执行人: "Executor",
    验收截止时间: "Acceptance Deadline",
    验收人: "Acceptor",
    进度: "Progress",
    状态: "Status",
    标签: "Tag",
    操作: "Action",
    请输入任务名称: "Please enter task name",
    我发起的: "Initiated by me",
    我执行的: "Executed by me",
    我审批的: "Approved by me",
    发起任务: "Initiate Task",
    执行人员: "Executors",
    部门: "Department",
    姓名: "Name",
    任务内容: "Task Content",
    工作时间: "Working Time",
    工单标签: "Work Order Tag",
    重要程度: "Importance",
    紧急程度: "Urgency",
    审核人员: "Reviewers",
    关联模型: "Associated Model",
    关联资料: "Associated Documents",
    截止时间: "Deadline",
    确定关联: "Confirm Association",
    确定: "Confirm",
    取消: "Cancel",
    显示全部文件: "Show All Files",
    请输入文件名: "Please enter file name",
    名字: "Name",
    选择集: "Selection Set",
    视点: "Viewpoint",
    催办: "Remind",
    删除: "Delete",
    启动: "Start",
    验收: "Accept",
    项目团队人员: "Project Team Members",
    请输入用户姓名: "Please enter user name",
    至: "To",
    开始日期: "Start Date",
    结束日期: "End Date",
    请选择: "Please select",
    选择日期时间: "Select Date and Time",
    任务进度: "Task Progress",
    调节进度: "Adjust Progress",
    请输入内容: "Please enter content",
    成果说明: "Result Description",
    附件: "Attachment",
    发送: "Send",
    申请审核: "Apply for Review",
    审核验收: "Review and Accept",
    验收意见: "Acceptance Comments",
    通过: "Pass",
    不通过: "Fail",
    任务详情: "Task Details",
    添加: "Add",
    截图: "Screenshot",
    查看: "View",
    名称: "Name",
    新增: "Add",
    时间范围: "Time Range",
    时间: "Time",
    内容: "Content",
    验收完成: "Acceptance Completed",
    请选择类型: "Please select type",
    输入关键字: "Enter keyword",
    新增资料: "Add Data",
    选取文件: "Select File",
    半公开: "Semi-public",
    公开: "Public",
    可见设置: "Visibility Settings",
    上传: "Upload",
    请选择人员: "Please select person",
    请输入名称: "Please enter name",
    账号: "Account",
    成功: "Success",
    失败: "Fail",
    此节点未绑定模型或选择集:
      "This node is not bound to a model or selection set",
    只可选择单模: "Only single model can be selected",
    未选择执行任务人员: "No execution task personnel selected",
    成功发布: "Published successfully",
    个工单: "work order",
    是否撤销该工单任务: "Whether to revoke the work order task?",
    已催办待执行: "Urged to execute",
    启动成功: "Started successfully",
    申请审核成功: "Application for review successful",
    成功发布: "Published successfully",
    个工单: "work order",
    上传文件大小不能超过500MB: "File size cannot exceed 500MB",
    当前限制选择1个文件本次选择了:
      "Currently limited to select 1 file, this time selected:",
    个文件: "files",
    共选择了: "Total selected",
    确定移除: "Confirm to remove",
  },
  //#endregion

  //#region 实景点位
  实景点位: {
    视点保存: "Viewpoint Save",
    请输入搜索内容: "Please enter search content...",
    涂鸦: "Doodle",
    保存: "Save",
    分享: "Share",
    发起碰撞: "Initiate Collision",
    新建视点目录: "Create Viewpoint Directory",
    重命名: "Rename",
    删除: "Delete",
    过滤器: "Filter",
    框选集: "Box Selection Set",
    增加: "Add",
    反选: "Invert Selection",
    收藏: "Favorite",
    新建目录: "Create Directory",
    名称: "Name",
    地点: "Location",
    拍摄时间: "Capture Time",
    类型: "Type",
    是否全景图: "Is Panorama",
    是: "Yes",
    否: "No",
    文件: "File",
    选择文件: "Select File",
    全景链接: "Panorama Link",
    提交: "Submit",
    添加分组: "Add Group",
    请选择: "Please Select",
    请输入名称: "Please Enter Name",
    序号: "No.",
    名称: "Name",
    绑定: "Bind",
    解绑: "Unbind",
    选择关联文档: "Select Associated Document",
    全部: "All",
    照片: "Photo",
    视频: "Video",
    上传用户: "Upload User",
    上传时间: "Upload Time",
    确认关联: "Confirm Association",
    参数: "parameter",
    条件: "condition",
    请选择筛选条件: "Please select filter condition",
    值: "value",
    资源类型: "Resource Type",
    关联: "Associate",
    此节点未绑定模型或选择集:
      "This node is not bound to a model or selection set",
    标签: "Tag",
    全景图片: "Panorama Image",
    图片: "Image",
    导出工程量: "Export Quantity",
    高级选项: "Advanced Options",
    参数: "parameter",
    条件: "condition",
    创建人: "Creator",
    操作: "Operation",
    发起话题讨论: "Initiate Topic Discussion",
    取消: "Cancel",
    确定: "Confirm",
    分类: "Classification",
    用户: "User",
  },
  //#endregion

  //#region 排序
  排序: {
    名称: "Name",
    时间: "Time",
    类型: "Type",
    大小: "Size",
  },
  //#endregion

};
















